"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _svgRequest = _interopRequireDefault(require("../../svgRequest"));
var _default = exports.default = {
  getSvg: function getSvg(url) {
    return (0, _svgRequest.default)({
      url: url,
      method: 'get'
    });
  }
};